import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Paper, Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import TableHeader from '../../../models/TableHeader';
import TooltipUI from '../../../components/UI/Tooltip/Tooltip';
import Grid24 from '../../../components/UI/Grid24';
import { getMoneyMask, useUtilStyles } from '../../../helpers';
import useStyles from './TableFiliais.style';

function TableFiliais({ content }) {
  const utilStyles = useUtilStyles();
  const styles = useStyles();


  const [columns] = useState([
    new TableHeader({
      id: 'nomeFilial', label: 'Nome da Filial', alignCell: 'center', minWidth: '250px',
    }),
    new TableHeader({
      id: 'qtdeProcessos', label: 'Qtde. Proc', minWidth: '200px', alignCell: 'center',
    }),
    new TableHeader({
      id: 'totalClientesNovos', label: 'Clientes Novos', minWidth: '200px', alignCell: 'center',
    }),
    new TableHeader({
      id: 'totalProcesso', label: 'Valor Total', minWidth: '260px', alignCell: 'center',
    }),
  ]);

  const rows = content?.map(item => ({
    id: item.idFilial,
    values: {
      nomeFilial: item.nomeFilial,
      qtdeProcessos: item.qtdeProcessos,
      totalClientesNovos: item.totalClientesNovos,
      totalProcesso: getMoneyMask(item.totalProcesso),
    },
  }));

  const getContent = (value, column) => {
    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom-start" interactive>
          <div className={styles.fitContent}>
            <pre
              className={styles.overFlowText}
              style={{ maxWidth: column.maxWidth - 16 }}
            >
              {column.format && typeof value === 'number' ? column.format(value) : value}
            </pre>
          </div>
        </TooltipUI>
      );
    }
    return (
      <pre>
        {column.format && typeof value === 'number' ? column.format(value) : value}
      </pre>
    );
  };

  const buildTableRow = row => (
    <TableRow>
      {columns.map((column) => {
        const value = row.values[column.id];
        return (
          <TableCell
            key={column.id}
            align={column.alignCell}
            style={{ textAlign: value === '-' ? 'center' : 'auto' }}
          >
            {getContent(value, column)}
          </TableCell>
        );
      })}
    </TableRow>
  );

  return (
    <>
      <Grid24 container isFormContainer spacing={1} className={utilStyles.mt16}>
        <Grid24 item xs={24} sm={24}>
          <Paper className={styles.wrapper}>
            <Table
              stickyHeader
              size="medium"
            >
              <TableHead>
                <TableRow>
                  {columns.map(column => (
                    <TableCell
                      id={column.id}
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map(row => buildTableRow(row))}
              </TableBody>
            </Table>
          </Paper>
        </Grid24>
      </Grid24>
    </>
  );
}

export default withRouter(TableFiliais);
